import Compressor from 'compressorjs'
import {ThumbnailSize} from '@/modules/media/types';

/**
 * Comprime una imagen
 *
 * @param file
 * @param options
 */
export function compress (file: File, options: Compressor.Options): Promise<Blob> {
    return new Promise((resolve, reject) => {
        // tslint:disable-next-line:no-unused-expression
        new Compressor(file, {...options, success: resolve, error: reject})
    })
}

interface ImageMeasures {
    height: number, width: number,
}

/**
 * Obtiene las medidas de una imagen
 *
 * @param file
 */
function loadImageMeasures (file: File): Promise<ImageMeasures> {
    const image = new Image()
    const promise = new Promise<ImageMeasures>(resolve => {
        image.onload = () => {
            resolve({ width: image.naturalWidth, height: image.naturalHeight})
        }
    })

    image.src = URL.createObjectURL(file)

    return promise
}

/**
 * Genera una lista de miniaturas con diferentes tamaños
 *
 * @param file
 * @param sizes
 */
export async function thumbnails (file: File, sizes: {[key: string]: number}) {
    const measures = await loadImageMeasures(file)
    const map = new Map<ThumbnailSize, Blob>()

    const generate = (size: number) => {
        return compress(file, {
            quality: 0.6,
            mimeType: 'image/jpeg',
            width: measures.width * (size / 100),
        })
    }

    for (const size of Object.keys(sizes)) {
        map.set(size as ThumbnailSize, await generate(sizes[size]))
    }

    return map
}
